import React from 'react';

import { Box, Typography } from '@mui/material';

import { Neutral } from '../Neutral';
import { ThumbsDown } from '../ThumbsDown';
import { ThumbsUp } from '../ThumbsUp';
import { SentimentAnalysisResults } from '../transcriptTypes';

export const TranscriptSentenceSentimentalAnalysis = ({ item }: { item: SentimentAnalysisResults }) => {
  return (
    <>
      <Box display="flex" alignItems="center">
        <Box sx={{ width: '18px', height: '18px', svg: { width: '18px', height: '18px' }, mr: 1 }}>
          {item.sentiment === 'NEUTRAL' && <Neutral />}
          {item.sentiment === 'POSITIVE' && <ThumbsUp />}
          {item.sentiment === 'NEGATIVE' && <ThumbsDown />}
        </Box>
        <Typography variant="h4" display="block" sx={{ textTransform: 'capitalize', color: 'grey.500' }}>
          {item.sentiment.toLowerCase()}
        </Typography>
      </Box>
      <Typography variant="text2">{item.text}</Typography>
    </>
  );
};
